import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-duree',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-duree.component.html',
  styleUrl: './traitement-data-duree.component.scss',
})
export class TraitementDataDureeComponent {
  @Input() patient: Patient | undefined;
}
